import { useParams } from "react-router-dom";
import FormPage from "../../components/forms/FormPage";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import usePlaceController from "../../controllers/placeController";
import { Place } from "../../types/place";
import FormMultiTextField from "../../components/forms/fields/basic/MultiTextInput";
import UserEnumGroupField from "../../components/forms/common/subForms/UserEnumGroupField";
import LinksListField from "../../components/forms/common/subForms/LinksListField";
import FormTextField from "../../components/forms/fields/basic/TextField";
import usePlaceLogic from "../../hooks/logic/placeLogic";

const AddEditPlacePage: React.FC = () => {
  const { _id } = useParams() as { _id: string };
  const controller = usePlaceController(_id || null);
  const {
    placeTypeEnum,
    placeCulturalSphereEnum,
    placeLinksTypeEnum,
    regionCountryAreasEnum,
  } = usePlaceLogic();

  const { isCreateMode } = controller;
  const formController = { ...controller, title: controller.editTitle };

  return (
    <FormPage<Place> controller={formController}>
      <FormTextField name="name" label="Name" placeholder="Name" required />
      {isCreateMode ? (
        <FormSelectField
          name="cultural_sphere"
          label="Cultural Sphere"
          useEnum={placeCulturalSphereEnum}
          placeholder="Select cultural sphere"
          required
        />
      ) : (
        <FormTextField name="cultural_sphere" label="Cultural Sphere" static />
      )}

      <FormMultiTextField
        name="other_designations"
        label="Other Designations"
        placeholder="Enter designations"
      />

      <LinksListField
        name="external_links"
        typeEnum={placeLinksTypeEnum}
        label="External Links"
        rowLabel="External Link"
        typeLabel="Link Type"
        valueLabel="Link"
        typePlaceHolder="Select link type"
        valuePlaceHolder="Enter Link"
      />

      <UserEnumGroupField
        name="region"
        label="Region"
        parentLabel="Region"
        childLabel="Sub Region"
        parentUserEnum={regionCountryAreasEnum}
        parentPlaceHolder="Select a region"
        childPlaceHolder="Select a sub-region"
      />

      <FormSelectField name="type" label="Type" useEnum={placeTypeEnum} />
    </FormPage>
  );
};

export default AddEditPlacePage;
